<div class="majora-folder-tree-view">
  <ul class="list-group list-group-flush" role="tree" aria-multiselectable="false">
    <ng-container *ngTemplateOutlet="renderNodes; context: { $implicit: nodesToRender, level: 0 }"></ng-container>
  </ul>

  <ng-template #renderNodes let-items let-level="level">
    @for (node of items; track node.id) {
      <li class="list-group-item border-0 p-0"
          role="treeitem"
          [attr.aria-expanded]="hasChildren(node) ? isExpanded(node) : null"
          [attr.aria-selected]="selectedId === node.id ? 'true' : 'false'"
          (click)="$event.stopPropagation(); select(node)">
        <div class="tree-row d-flex align-items-center gap-2 py-1 pe-2" [class.active]="selectedId === node.id" [ngStyle]="getRowStyles(node)" [style.paddingLeft.px]="8 + (level * 16)">
          @if (hasChildren(node)) {
            <button
                    type="button"
                    class="btn btn-sm btn-link p-0 toggle-btn"
                    (click)="toggle(node); $event.stopPropagation()"
                    [attr.aria-label]="(isExpanded(node) ? 'Collapse ' : 'Expand ') + node.name">
              <span class="chevron" [class.expanded]="isExpanded(node)"></span>
            </button>
          } @else {
            <span class="placeholder-icon"></span>
          }
          @if (node.icon) {
            <i class="me-1" [class]="node.icon"></i>
          }
          <span class="node-label text-truncate">{{ node.name }}</span>
        </div>
        @if (hasChildren(node) && isExpanded(node)) {
          <ul
              class="list-group list-group-flush"
              role="group">
            <ng-container *ngTemplateOutlet="renderNodes; context: { $implicit: node.children, level: level + 1 }"></ng-container>
          </ul>
        }
      </li>
    }
  </ng-template>
</div>
